import { Heart, TrendingUp, Users, CircleDollarSign } from 'lucide-react';

export function GivingBack() {
  const features = [
    {
      icon: CircleDollarSign,
      title: 'automated giving',
      description: 'a small portion of every booking automatically goes to the community fund'
    },
    {
      icon: Heart,
      title: 'annual distribution',
      description: 'funds are distributed yearly to participating courses for improvements'
    },
    {
      icon: TrendingUp,
      title: 'course growth',
      description: 'even low-booking courses benefit and can invest in improvements'
    },
    {
      icon: Users,
      title: 'stronger community',
      description: 'better courses attract more players, creating a positive cycle'
    }
  ];

  return (
    <section id="giving-back" className="py-16 lg:py-24 bg-accent/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground lowercase mb-4">
            giving back to the <span className="text-primary">community</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            every booking on <span className="font-bold text-primary">discgo</span> contributes to a community fund that helps all participating courses improve and grow,
            creating a stronger disc golf ecosystem for everyone
          </p>
        </div>



        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group"
              >
                <div className="space-y-4">
                  <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center group-hover:bg-primary group-hover:text-white transition-all duration-300">
                    <Icon className="w-6 h-6 text-primary group-hover:text-white" />
                  </div>
                  
                  <div className="space-y-2">
                    <h4 className="font-bold text-foreground lowercase">
                      {feature.title}
                    </h4>
                    <p className="text-sm text-muted-foreground">
                      {feature.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}